import React, {useState} from 'react'
import {motion} from 'framer-motion'
import { staggerContainer } from '../../utils/motion'
import {AppWrap} from '../../wrapper'

import { ExploreCard} from '../../components'
import { images } from '../../constants';
import './Services.scss'


const Services = () => {
 
  const [active, setActive] = useState(1);

  const exploreServices  = [
    {
      id: 1, 
      title:'Education & Training',  
      description: 'We empower individuals, teams, and institutions with the knowledge and skills required to thrive in a fast-changing world. Our offerings include digital skills training, professional development programs, curriculum development, and management consulting for SMEs and institutions.', 
      imgUrl: images.bg1
    },
    {
      id: 2, 
      title:'Business Expansion & Market Entry',  
      description: 'For companies looking to establish or expand their presence in Africa, we provide comprehensive market insights and execution support. We help businesses enter African markets confidently with clarity, cultural intelligence, and strategic guidance.', 
      imgUrl: images.bg2
    },
    {
      id: 3, 
      title:'Marketing & Brand Development',  
      description: 'We build brands that stand out, communicate clearly, and attract the right audience. Our capabilities include marketing strategy development, brand identity creation, digital marketing materials, and content development for campaigns and promotions.', 
      imgUrl: images.bg3
    },
    {
      id: 4,
      title:'Technology & Software Development',  
      description: 'Scoolj Lab is the technology engine of our organization. We design and build digital products that solve real business problems. We specialize in website development, mobile apps, desktop software, UI/UX design, and product management from concept to deployment.', 
      imgUrl: images.bg4
    }
  ]
  
  return (
    <>
      <h2 className='head-text'>
        Our Core <span>Services</span> <br/> 
        Bridging <span>Education</span>, <span>Business</span> & <span>Technology</span>
      </h2>
  
      <section className="app__work" id="services">
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{once: false, amount: 0.25}}
          className= "app__work-item" 
        >
          <div className="app__work-exp">
            {exploreServices.map((service, index) =>(
              <ExploreCard
                key={service.id}
                {...service}
                index={index}
                active={active}
                handleClick={setActive}
              />
            ))}
          </div>
        </motion.div>
      </section>
    </>
  )
}

export default AppWrap(Services, 'services')